<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary sticky-top mb-3">
      <div class="container-fluid">
        <div class="col-4 ms-0">
          <h1 class="navbar-brand mb-0">
            <Logo />
          </h1>
        </div>
        <h1 class="mt-3 text-white">Support Issue {{ standalone }}</h1>
      </div>
    </nav>
    <Maintenance tablename="g_supportissues" :standalone="standalone" />
  </div>  
</template>
<script>
import Maintenance from './Maintenance.vue'
import Logo from './Logo'

export default {
    name: 'SupportIssue',
    components: {
        Maintenance,
        Logo,
    },
    data: function() {
      return {
        standalone: this.$route.params.id,
      }
    }
}
</script>
